__webpack_require__.p = "//static.hsappstatic.net/whisper-core/static-1.7746/";